<ion-content>
	<ion-grid *ngIf="stage==='register'">
		<ion-row class="title-login">
		<ion-col size="2"></ion-col>
		<ion-col>
			<h2>Join the Trade program</h2>
		</ion-col>
			<ion-col (click)="dimiss()" size="2" class="close-icon">
				<img src="../../../assets/icon/close.svg" alt="close"/>
			</ion-col>
		</ion-row>
		<ion-row>
			<ion-col size="5.8">
				<ion-item lines="none" class="each-input">
					<ion-input labelPlacement="stacked" placeholder="First Name" (ngModelChange)="firstNameError=null" [(ngModel)]="firstName">
						<ion-icon slot="start" aria-hidden="true" src="/assets/icon/user.svg"></ion-icon>
					</ion-input>
				</ion-item>
				<span class="input-error" *ngIf="firstNameError">{{firstNameError}}</span>
			</ion-col>
			<ion-col></ion-col>
			<ion-col size="5.8">
				<ion-item lines="none" class="each-input">
					<ion-input labelPlacement="stacked" placeholder="Last Name" (ngModelChange)="lastNameError=null" [(ngModel)]="lastName">
						<ion-icon slot="start" aria-hidden="true" src="/assets/icon/user.svg"></ion-icon>
					</ion-input>
				</ion-item>
				<span class="input-error" *ngIf="lastNameError">{{lastNameError}}</span>
			</ion-col>
			<ion-col size="5.8">
				<ion-item lines="none" class="each-input">
					<ion-input labelPlacement="stacked" placeholder="Email Address" (ngModelChange)="emailError=null" [(ngModel)]="email">
						<ion-icon slot="start" aria-hidden="true" src="/assets/icon/mail.svg"></ion-icon>
					</ion-input>
				</ion-item>
				<span class="input-error" *ngIf="emailError">{{emailError}}</span>
			</ion-col>
			<ion-col></ion-col>
			<ion-col size="5.8">
				<ion-item lines="none" class="each-input">
					<ion-input labelPlacement="stacked" type="tel" placeholder="Phone Number" (ngModelChange)="phoneNumberError=null" [(ngModel)]="phoneNumber">
						<ion-icon slot="start" aria-hidden="true" src="/assets/icon/call-d.svg"></ion-icon>
					</ion-input>
				</ion-item>
				<span class="input-error" *ngIf="phoneNumberError">{{phoneNumberError}}</span>
			</ion-col>
			<ion-col size="5.8">
				<ion-item lines="none" class="each-input">
					<ion-input labelPlacement="stacked" placeholder="Company Name" (ngModelChange)="companyNameError=null" [(ngModel)]="companyName">
						<ion-icon slot="start" aria-hidden="true" src="/assets/icon/company.svg"></ion-icon>
					</ion-input>
				</ion-item>
				<span class="input-error" *ngIf="companyNameError">{{companyNameError}}</span>
			</ion-col>
			<ion-col></ion-col>
			<ion-col size="5.8">
				<ion-item lines="none" class="each-input">
					<ion-input labelPlacement="stacked" placeholder="Company Website" (ngModelChange)="companyWebsiteError=null" [(ngModel)]="companyWebsite">
						<ion-icon slot="start" aria-hidden="true" src="/assets/icon/company.svg"></ion-icon>
					</ion-input>
				</ion-item>
				<span class="input-error" *ngIf="companyWebsiteError">{{companyWebsiteError}}</span>
			</ion-col>
			<ion-col class="title-join" size="12">
				<h4>Type</h4>
				<ion-item lines="none" class="each-input">
					<ion-radio-group mode="md" value="end" [(ngModel)]="type" (ngModelChange)="typeError=null" value="strawberries" style="width: 100%">
						<ion-radio value="end" mode="md" labelPlacement="end" value="distributor">Distributor</ion-radio>

						<ion-radio value="end" mode="md" labelPlacement="end" value="trade">Trade</ion-radio>
					</ion-radio-group>
				</ion-item>
				<span class="input-error" *ngIf="typeError">{{typeError}}</span>
			</ion-col>
			<ion-col size="12">
				<ion-item lines="none" class="each-input textar">
					<ion-textarea [(ngModel)]="message" (ngModelChange)="messageError=null" style="height: 100px" labelPlacement="stacked" placeholder="Message">
					</ion-textarea>
				</ion-item>
				<span class="input-error" *ngIf="messageError">{{messageError}}</span>
			</ion-col>
			<ion-col>
<!--				<app-captcha [reload]="recaptchaReload" [Captcha]="captcha" [InputError]="captchaError" (InputChanged)="captchaUserInputChanged($event)" (getCaptcha)="CaptchaReceived($event)"></app-captcha>-->
			</ion-col>
			<ion-col size="12" class="submit-auth">
				<ion-button (click)="SendRegistrationData()"> <ion-spinner *ngIf="loading"></ion-spinner> {{loading?'':'Submit'}}</ion-button>
			</ion-col>
		</ion-row>

        <ion-row>
			<ion-col>
			  <p style="color: var(--ion-color-primary);text-align: center;margin: 15px 0;cursor: pointer;" (click)="openRegister()">Already have an account? Log in</p>
			</ion-col>
		  </ion-row>
	</ion-grid>
	<ion-grid style="height: 100%;" *ngIf="stage==='result'">
		<ion-row class="title-login">
			<ion-col size="2"></ion-col>
			<ion-col>
				<h2>Join the Trade program</h2>
			</ion-col>
				<ion-col (click)="dimiss()" size="2" class="close-icon">
					<img src="../../../assets/icon/close.svg" alt="close"/>
				</ion-col>
			</ion-row>
		<ion-row style="height: 70%;">
			<ion-col>
				<div class="register-success">
					<img src="../../../assets/icon/check-circle.svg" alt="success"/>
					<h3>Your registration was successful</h3>
					<p>We will contact you shortly.</p>
				</div>
			</ion-col>
		</ion-row>
    <ion-row>
      <ion-col>
        <p style="color: var(--ion-color-primary);text-align: center;margin: 27px;cursor: pointer;" (click)="openRegister()">Already have account? Sign in</p>
      </ion-col>
    </ion-row>
	</ion-grid>
</ion-content>
